/**
 * The practice page's AudioContext, reused from one take to the next — but
 * never once it is closed: a closed context's AudioWorklet scope is gone,
 * so the next take's AudioWorkletNode cannot be built on it ("AudioWorklet
 * does not have a valid AudioWorkletGlobalScope") and the take never starts.
 * Returns the context to record on next, or null to make a fresh one (and
 * load the worklet module into it again).
 */
export function reusableContext(context) {
  if (!context || context.state === 'closed') return null
  return context
}
